import { render, staticRenderFns } from "./add-detail.vue?vue&type=template&id=5b14c429&scoped=true&"
import script from "./add-detail.vue?vue&type=script&lang=ts&"
export * from "./add-detail.vue?vue&type=script&lang=ts&"
import style0 from "./add-detail.vue?vue&type=style&index=0&id=5b14c429&prod&lang=css&"
import style1 from "./add-detail.vue?vue&type=style&index=1&id=5b14c429&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b14c429",
  null
  
)

export default component.exports